/**
 * LoadingState — skeleton loading placeholders
 */

import { createElement } from '../utils/dom.js';

const SKELETON_COUNT = 8;

export default class LoadingState {
  constructor() {
    this._el = null;
  }

  /**
   * Render loading skeletons
   * @param {HTMLElement} container
   */
  render(container) {
    this._el = createElement('div', 'grb-widget--loading');

    const grid = createElement('div', 'grb-widget--loading-grid');
    for (let i = 0; i < SKELETON_COUNT; i++) {
      const skeleton = createElement('div', 'grb-widget--skeleton-card');
      skeleton.appendChild(createElement('div', 'grb-widget--skeleton-image'));
      skeleton.appendChild(createElement('div', 'grb-widget--skeleton-line'));
      skeleton.appendChild(createElement('div', 'grb-widget--skeleton-line grb-widget--skeleton-line-short'));
      grid.appendChild(skeleton);
    }

    this._el.appendChild(grid);
    container.appendChild(this._el);
  }

  show() {
    if (this._el) this._el.style.display = '';
  }

  hide() {
    if (this._el) this._el.style.display = 'none';
  }

  destroy() {
    if (this._el && this._el.parentNode) {
      this._el.parentNode.removeChild(this._el);
    }
    this._el = null;
  }
}
